import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { navbarLinks, SERVICES, RESOURCES } from "../constants/navbarLinks";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ScrollTop from "../components/ScrollTop";

function HashScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (pathname !== "/") return undefined;

    const id = hash.replace("#", "");
    if (!id || id === "home") {
      if (hash === "#home") {
        document.getElementById("home")?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      return undefined;
    }

    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);

    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}

const PageLayout = () => {
  const { pathname } = useLocation();

  const sectionTheme = pathname.startsWith("/simmarkets")
    ? "theme-market"
    : pathname.startsWith("/simverify") || pathname.startsWith("/simcollect")
      ? "theme-product"
      : undefined;

  return (
    <>
      <HashScroll />
      <Navbar links={navbarLinks} services={SERVICES} resources={RESOURCES} />
      <div className={sectionTheme}>
        <main id="main">
          <Outlet />
        </main>
        <Footer />
        <ScrollTop />
      </div>
    </>
  );
};

export default PageLayout;
